"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.choicesFactory = void 0;
/**
 * Creates a new Choices object.
 */
function choicesFactory({ items, name, description = '', }) {
    const _choiceMap = {};
    const _keyMap = {};
    const _labelMap = {};
    const _descriptionMap = {};
    const _choices = [];
    items.forEach(({ key, value, label, description: itemDescription }) => {
        _choiceMap[key] = value;
        _labelMap[value] = label;
        _keyMap[value] = key;
        _descriptionMap[value] = itemDescription !== null && itemDescription !== void 0 ? itemDescription : '';
        _choices.push(value);
    });
    function getLabel(value) {
        return _labelMap[value];
    }
    function getKey(value) {
        return _keyMap[value];
    }
    function getChoices() {
        return _choices;
    }
    function getItems() {
        return items;
    }
    function getKeys() {
        return Object.keys(_choiceMap);
    }
    function getDescription(value) {
        return _descriptionMap[value];
    }
    function isValidChoice(value) {
        return _choices.includes(value);
    }
    return Object.assign({ getLabel,
        getChoices,
        getItems,
        getKey,
        getKeys,
        getDescription,
        isValidChoice,
        name,
        description }, _choiceMap);
}
exports.choicesFactory = choicesFactory;
//# sourceMappingURL=choices.js.map